export const KALOS_BRAND_BUCKET = 'kalos-web-assets';

export const KALOS_LOGO_KEY = {
  default: 'brand/logo-sm.png',
  full: 'brand/logo.png',
  onDark: 'brand/logo-on-dark-sm.png',
  onDarkFull: 'brand/logo-on-dark.png',
  mark: 'brand/mark.png',
} as const;

export type KalosLogoVariant = keyof typeof KALOS_LOGO_KEY;

export const kalosLogoQueryKey = (variant: KalosLogoVariant) =>
  ['s3', KALOS_BRAND_BUCKET, KALOS_LOGO_KEY[variant]] as const;
